import { frontendURL } from '../../../helper/URLHelper';
import TicketsList from './TicketsList.vue';
import TicketDetails from './TicketDetails.vue';
import TicketWorkspace from './TicketWorkspace.vue';
import TicketDashboard from './TicketDashboard.vue';
import TicketReports from './TicketReports.vue';
import ServiceOrderReports from './ServiceOrderReports.vue';

const TICKET_PERMISSIONS = ['administrator', 'agent'];

export const routes = [
  // All tickets — full-page Tasks-style list + board
  {
    path: frontendURL('accounts/:accountId/tickets'),
    name: 'tickets_list',
    meta: { permissions: TICKET_PERMISSIONS },
    component: TicketsList,
  },
  // Single ticket — full-page Tasks-style detail
  {
    path: frontendURL('accounts/:accountId/tickets/:ticketId(\\d+)'),
    name: 'ticket_details',
    meta: { permissions: TICKET_PERMISSIONS },
    component: TicketDetails,
    props: route => ({ ticketId: route.params.ticketId }),
  },
  // Mentions
  {
    path: frontendURL('accounts/:accountId/tickets/mentions'),
    name: 'ticket_mentions',
    meta: { permissions: TICKET_PERMISSIONS },
    component: TicketWorkspace,
    props: () => ({ ticketType: 'mention' }),
  },
  {
    path: frontendURL('accounts/:accountId/tickets/mentions/:ticketId'),
    name: 'ticket_through_mentions',
    meta: { permissions: TICKET_PERMISSIONS },
    component: TicketWorkspace,
    props: route => ({
      ticketType: 'mention',
      ticketId: route.params.ticketId,
    }),
  },
  // Unattended
  {
    path: frontendURL('accounts/:accountId/tickets/unattended'),
    name: 'ticket_unattended',
    meta: { permissions: TICKET_PERMISSIONS },
    component: TicketWorkspace,
    props: () => ({ ticketType: 'unattended' }),
  },
  {
    path: frontendURL('accounts/:accountId/tickets/unattended/:ticketId'),
    name: 'ticket_through_unattended',
    meta: { permissions: TICKET_PERMISSIONS },
    component: TicketWorkspace,
    props: route => ({
      ticketType: 'unattended',
      ticketId: route.params.ticketId,
    }),
  },
  // Reports (configurable ticket reports)
  {
    path: frontendURL('accounts/:accountId/tickets/reports'),
    name: 'tickets_reports',
    meta: { permissions: TICKET_PERMISSIONS },
    component: TicketReports,
  },
  // Dashboard (full-page, not workspace)
  {
    path: frontendURL('accounts/:accountId/tickets/dashboard'),
    name: 'tickets_dashboard',
    meta: { permissions: TICKET_PERMISSIONS },
    component: TicketDashboard,
  },
  // Service Order Reports
  {
    path: frontendURL('accounts/:accountId/orders/reports'),
    name: 'service_order_reports',
    meta: { permissions: TICKET_PERMISSIONS },
    component: ServiceOrderReports,
  },
];

export default routes;
